export const EXPENSE_TYPE_OPTIONS = [
  {
    label: "Select",
    value: "",
  },
  {
    label: "5418 - Ad Hoc Contracted Labour",
    value: "5418",
  },
  { label: "5420 - Media Costs", value: "5420" },
  {
    label: "5426 - Contracted Labour",
    value: "5426",
  },
  {
    label: "5435 - Interactive Costs",
    value: "5435",
  },
  { label: "5500 - Creative Costs", value: "5500" },
  { label: "5510 - Strategy Costs", value: "5510" },
  {
    label: "5515 - Client Services Costs",
    value: "5515",
  },
];
